// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dl-iam-access-dialog-access-list-block {
  padding: 16px 20px;
  border: 1px solid var(--dl-color-border);
  border-radius: var(--g-border-radius-l);
}
.dl-iam-access-dialog-access-list-block .dl-iam-access-dialog-access-list-block__collapse-header {
  display: flex;
}
.dl-iam-access-dialog-access-list-block .dl-iam-access-dialog-access-list-block__collapse-title {
  flex: 1;
}
.dl-iam-access-dialog-access-list-block__title {
  flex: 1;
  font-size: 15px;
  line-height: 20px;
  font-weight: 500;
}
.dl-iam-access-dialog-access-list-block__counter {
  margin-left: 8px;
  color: var(--g-color-text-secondary);
}
.dl-iam-access-dialog-access-list-block__content {
  display: flex;
  flex-direction: column;
}`, "",{"version":3,"sources":["webpack://./src/ui/components/IamAccessDialog/AccessList/Block/Block.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,wCAAA;EACA,uCAAA;AACJ;AACI;EACI,aAAA;AACR;AAEI;EACI,OAAA;AAAR;AAGI;EACI,OAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AADR;AAII;EACI,gBAAA;EACA,oCAAA;AAFR;AAKI;EACI,aAAA;EACA,sBAAA;AAHR","sourcesContent":[".dl-iam-access-dialog-access-list-block {\n  padding: 16px 20px;\n  border: 1px solid var(--dl-color-border);\n  border-radius: var(--g-border-radius-l);\n}\n.dl-iam-access-dialog-access-list-block .dl-iam-access-dialog-access-list-block__collapse-header {\n  display: flex;\n}\n.dl-iam-access-dialog-access-list-block .dl-iam-access-dialog-access-list-block__collapse-title {\n  flex: 1;\n}\n.dl-iam-access-dialog-access-list-block__title {\n  flex: 1;\n  font-size: 15px;\n  line-height: 20px;\n  font-weight: 500;\n}\n.dl-iam-access-dialog-access-list-block__counter {\n  margin-left: 8px;\n  color: var(--g-color-text-secondary);\n}\n.dl-iam-access-dialog-access-list-block__content {\n  display: flex;\n  flex-direction: column;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
